<form [formGroup]="form" (ngSubmit)="onConfirm()">
	<div class="p-fluid">
		<p-messages *ngIf="message" severity="warn" [closable]="false">
			<ng-template pTemplate>
				<span [innerHTML]="message"></span>
			</ng-template>
		</p-messages>

		<div class="field">
			<label for="reason">{{ label }}*</label>
			<textarea
				id="reason"
				pInputTextarea
				formControlName="reason"
				[rows]="4"
				[maxlength]="maxLength"
				placeholder="Enter a reason"
			></textarea>
			<div class="flex justify-content-between align-items-center mt-1">
				<small class="p-error" *ngIf="form.get('reason')?.touched && form.get('reason')?.hasError('required')">
					Reason is required.
				</small>
				<small class="text-color-secondary ml-auto">
					{{ (form.get('reason')?.value || '').length }} / {{ maxLength }}
				</small>
			</div>
		</div>

		<div class="flex justify-content-end gap-2">
			<p-button label="Cancel" severity="secondary" type="button" (click)="onCancel()" />
			<p-button [label]="confirmLabel" type="submit" [disabled]="isInvalid" />
		</div>
	</div>
</form>
